import { render, staticRenderFns } from "./BranchData.vue?vue&type=template&id=0a58496a&"
import script from "./BranchData.vue?vue&type=script&lang=js&"
export * from "./BranchData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports